import { Box, Grid, Avatar, Tooltip } from '@mui/material';
import { departmentIcons } from '../../../module/yachtDashboard/conf/Data.conf';
import { Fragment } from 'react';

const CardHeader = ({ color, departmentName }) => {
  return (
    <Fragment>
      <Grid item xs={2} sm={0.5}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Tooltip title={departmentName}>
            <Avatar
              sx={{
                bgcolor: color,
                color: 'white',
                width: 42,
                height: 42,
                fontSize: '1.2rem',
                fontWeight: 'bold',
              }}
            >
              {departmentIcons?.[departmentName] || departmentName?.charAt(0)}
            </Avatar>
          </Tooltip>
        </Box>
      </Grid>
    </Fragment>
  );
};

export default CardHeader;
